<ui-dialog
    [open]="openBankingInfoDialog"
    header="payroll.setup.findingBankInformation"
    size="small"
    (closing)="toggleBankingInfoDialog()"
    primaryButtonLabel="close"
    (primaryButtonPressed)="toggleBankingInfoDialog()"
    class="bank-info-modal"
>
    <img class="bank-info-modal_img" src="/assets/img/misc/cheque.png" />
</ui-dialog>

<app-header title="payroll.setup.companyInformation" [ngSwitch]="mode">
    <div class="buttons" *ngSwitchCase="'view'">
        <ui-button
            *ngIf="!hasPaidPayrolls"
            type="link"
            [disabled]="authorizationDocumentsHaveBeenUploaded"
            (click)="editCompanyInformation()"
        >
            <mat-icon svgIcon="edit"></mat-icon>
            {{ 'edit' | translate }}
        </ui-button>
        <mat-icon
            *ngIf="authorizationDocumentsHaveBeenUploaded"
            svgIcon="info"
            [matTooltip]="
                'payroll.setup.companyInformationCannotBeEditedSinceAuthorizationDocumentsHaveBeenUploaded' | translate
            "
        >
        </mat-icon>
    </div>
    <div class="buttons" *ngSwitchCase="'edit'">
        <ui-button type="link" (click)="cancelEdit()">{{ 'cancel' | translate }}</ui-button>
        <ui-button type="link" (click)="updateCompanyInformation()">{{
            'payroll.setup.saveChanges' | translate
        }}</ui-button>
    </div>
</app-header>

<div class="header-content margin-bottom-4">
    <p>{{ 'payroll.setup.thisInformationIsUsedWhenHumiRemitsPayrollDeductions' | translate }}</p>
    <p>
        <a target="_blank" href="{{ '12156278935063' | i18nHelpCentre }}"
            >{{ 'payroll.setup.learnAboutRemitterTypes' | translate }}
        </a>
    </p>
    <p>
        <a (click)="toggleBankingInfoDialog()">{{ 'payroll.setup.needHelpFindingYourBankInformation' | translate }}</a>
    </p>
</div>

<form #form="ngForm" autocomplete="off" *ngIf="companyInformation">
    <div class="app-grid">
        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.legalCompanyName' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="legal_name"
                #legalName="ngModel"
                [(ngModel)]="companyInformation.doingBusinessAsName"
                required
                [disabled]="mode == 'view'"
            />
            <mat-error *ngIf="legalName.invalid">{{ legalName.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.depositNameOnPaystub' | translate }}</mat-label>
            <input
                type="text"
                matInput
                name="deposit_name"
                #depositName="ngModel"
                [(ngModel)]="companyInformation.customOriginator"
                required
                [disabled]="mode == 'view'"
            />
            <mat-error *ngIf="depositName.invalid">{{ depositName.errors | formErrors }}</mat-error>
        </mat-form-field>
        <ui-info
            class="columns-1"
            text="{{ 'payroll.setup.thisIsTheNameThatWillAppearOnEmployeesPaystubsAndBank' | translate }}"
        ></ui-info>
    </div>

    <hr class="margin-y-4" />

    <h2>{{ 'payroll.setup.canadaRevenueAgencyCraInformation' | translate }}</h2>

    <div class="app-grid">
        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.craBusinessNumber' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="cra_business_number"
                #businessNumber="ngModel"
                [(ngModel)]="companyInformation.businessNumber"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.numbersOnly9Digits' | translate }}</mat-hint>
            <mat-error *ngIf="businessNumber.invalid">{{ businessNumber.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.craProgramCode' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="cra_program_code"
                #programCode="ngModel"
                [(ngModel)]="companyInformation.programCode"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.lettersOnly2Characters' | translate }}</mat-hint>
            <mat-error *ngIf="programCode.invalid">{{ programCode.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.craReferenceNumber' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="cra_reference_number"
                #referenceNumber="ngModel"
                [(ngModel)]="companyInformation.referenceNumber"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.numbersOnly4Digits' | translate }}</mat-hint>
            <mat-error *ngIf="referenceNumber.invalid">{{ referenceNumber.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label appRemoveAriaOwns>{{ 'payroll.setup.remitterType' | translate }}</mat-label>
            <mat-select
                matInput
                name="remitter_type"
                #remitterType="ngModel"
                [(ngModel)]="companyInformation.remitterType"
                required
                [disabled]="mode == 'view'"
            >
                <mat-option value="quarterly">{{ 'payroll.setup.quarterly' | translate }}</mat-option>
                <mat-option value="monthly">{{ 'payroll.setup.monthly' | translate }}</mat-option>
                <mat-option value="threshold_1">{{ 'payroll.setup.threshold1Accelerated' | translate }}</mat-option>
                <mat-option value="threshold_2">{{ 'payroll.setup.threshold2Accelerated' | translate }}</mat-option>
            </mat-select>
            <mat-error *ngIf="remitterType.invalid">{{ remitterType.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>

    <hr class="margin-y-4" />

    <ng-container *ngIf="hasQcPayrollFeature">
        <h2>{{ 'payroll.setup.revenueQuebecRqInformation' | translate }}</h2>

        <div class="app-grid">
            <mat-form-field class="columns-3">
                <mat-label>{{ 'payroll.setup.quebecEnterpriseNumberNeq' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="quebec_enterprise_number"
                    #quebecEnterpriseNumber="ngModel"
                    [(ngModel)]="companyInformation.quebecEnterpriseNumber"
                    [disabled]="mode == 'view'"
                    placeholder="1234567890"
                    required
                />
                <mat-hint>{{ 'payroll.setup.numbersOnly10Digits' | translate }}</mat-hint>
                <mat-error *ngIf="quebecEnterpriseNumber.invalid">{{
                    quebecEnterpriseNumber.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-2">
                <mat-label>{{ 'payroll.setup.revenueQuebecNumber' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    name="rq_registration"
                    #rqRegistration="ngModel"
                    [(ngModel)]="companyInformation.rqRegistration"
                    [disabled]="mode == 'view'"
                    placeholder="1234567890"
                    required
                />
                <mat-hint>{{ 'payroll.setup.numbersOnly10Digits' | translate }}</mat-hint>
                <mat-error *ngIf="rqRegistration.invalid">{{ rqRegistration.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-2">
                <input
                    matInput
                    type="text"
                    name="rq_program_code"
                    #rqProgramCode="ngModel"
                    [(ngModel)]="companyInformation.rqProgramCode"
                    [disabled]="mode == 'view'"
                    placeholder="RS"
                    required
                />
                <mat-hint>{{ 'payroll.setup.lettersOnly2Characters' | translate }}</mat-hint>
                <mat-error *ngIf="rqProgramCode.invalid">{{ rqProgramCode.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-2">
                <input
                    matInput
                    type="text"
                    name="rq_reference_number"
                    #rqReferenceNumber="ngModel"
                    [(ngModel)]="companyInformation.rqReferenceNumber"
                    [disabled]="mode == 'view'"
                    placeholder="1234"
                    required
                />
                <mat-hint>{{ 'payroll.setup.numbersOnly4Digits' | translate }}</mat-hint>
                <mat-error *ngIf="rqReferenceNumber.invalid">{{ rqReferenceNumber.errors | formErrors }}</mat-error>
            </mat-form-field>

            <mat-form-field class="columns-3">
                <mat-label appRemoveAriaOwns>{{ 'payroll.setup.remittanceFrequency' | translate }}</mat-label>
                <mat-select
                    matInput
                    name="rq_remittance_frequency"
                    #rqRemittanceFrequency="ngModel"
                    [(ngModel)]="companyInformation.rqRemittanceFrequency"
                    [disabled]="mode == 'view'"
                    required
                >
                    <mat-option *ngFor="let option of rqRemittanceFrequencyOptions" [value]="option.value">{{
                        option.label | translate
                    }}</mat-option></mat-select
                >
                <mat-error *ngIf="rqRemittanceFrequency.invalid">{{
                    rqRemittanceFrequency.errors | formErrors
                }}</mat-error>
            </mat-form-field>
        </div>

        <hr class="margin-y-4" />
    </ng-container>

    <h2>{{ 'payroll.setup.bankingInformation' | translate }}</h2>

    <div class="app-grid">
        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.bankInstitution' | translate }}</mat-label>
            <input
                type="text"
                matInput
                name="bank_institution"
                #bankInstitution="ngModel"
                [(ngModel)]="companyInformation.institution"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.numbersOnly3Digits' | translate }}</mat-hint>
            <mat-error *ngIf="bankInstitution.invalid">{{ bankInstitution.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.bankBranch' | translate }}</mat-label>
            <input
                type="text"
                matInput
                name="bank_branch"
                #bankBranch="ngModel"
                [(ngModel)]="companyInformation.branch"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.numbersOnly5Digits' | translate }}</mat-hint>
            <mat-error *ngIf="bankBranch.invalid">{{ bankBranch.errors | formErrors }}</mat-error>
        </mat-form-field>

        <mat-form-field class="columns-3">
            <mat-label>{{ 'payroll.setup.bankAccount' | translate }}</mat-label>
            <input
                type="text"
                matInput
                name="bank_account"
                #bankAccount="ngModel"
                [(ngModel)]="companyInformation.account"
                required
                [disabled]="mode == 'view'"
            />
            <mat-hint>{{ 'payroll.setup.numbersOnlyBetween5And12Digits' | translate }}</mat-hint>
            <mat-error *ngIf="bankAccount.invalid">{{ bankAccount.errors | formErrors }}</mat-error>
        </mat-form-field>
    </div>
</form>
